import { CreateGroupRequest } from '../../create-study-group/create-group-request';
import { EditGroupRequest } from '../../edit-study-group/edit-study-group-request';

export enum SampleTrackingResultAction {
    close,
    create,
    delete,
    edit,
    save,
    deleteReport,
}

export interface SampleTrackingDialogResult {
    action: SampleTrackingResultAction;
    createRequest?: CreateGroupRequest;
    groupPk?: number;
    editRequest?: EditGroupRequest;

}